import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, first, map, switchMap } from 'rxjs/operators';

import { AuthService } from '@auth0/auth0-angular';

import { PATHS_DICT, ROUTES_PREFIX } from '../auth.constants';
import { getAppMetadataClaim, isShAdmin } from '../utils/sh-admin-claim';

/**
 * Lets only a SmartHead administrator into the application, any other logged user gets the "no access" page
 * (the API refuses the admin endpoints for them anyway). A user who isn't logged in is left to `AuthGuard`.
 */
export const adminGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isLoading$.pipe(
    filter(isLoading => !isLoading),
    first(),
    switchMap(() => authService.idTokenClaims$.pipe(first())),
    map(claims => {
      if (!claims) {
        return false;
      }

      return isShAdmin(getAppMetadataClaim(claims)) || router.createUrlTree([`/${ROUTES_PREFIX}/${PATHS_DICT.NO_ACCESS}`]);
    })
  );
};
